import aafaLogo from './aafa-logo.png';
import afirmLogo from '../../../../responsiblepractices/OrganizationImages/afirm_logo.png';
import betterWorkLogo from './better-work-logo.png';
import canopyLogo from './canopy-logo.png';
import cascaleLogo from './cascale-logo-banner_cr.png';
import fesiLogo from './fesi-logo.jpg';
import lwgLogo from './lwg-logo.png';
import outdoorIndustryLogo from './oia-logo.png';
import rilaLogo from './rila-logo.jpg';
import riseLogo from './rise-logo.png';
import texttileEchangeLogo from './textile-exchange-logo.png';
import wfsgiLogo from './WFSGI.jpeg';
import corpLogo from './corp_logo.png';

const PartnershipImages = [
    { id: 0, src: afirmLogo, name: "afirm-logo" },
    { id: 1, src: aafaLogo, name: "aafa-logo" },
    { id: 2, src: betterWorkLogo, name: "better-work-logo" },
    { id: 3, src: corpLogo, name: "corp-logo" },
    { id: 4, src: canopyLogo, name: "canopy-logo" },
    { id: 5, src: cascaleLogo, name: "cascale-logo" },
    { id: 6, src: fesiLogo, name: "fesi-logo" },
    { id: 7, src: lwgLogo, name: "lwg-logo" },
    { id: 8, src: outdoorIndustryLogo, name: "oia-logo" },
    { id: 9, src: rilaLogo, name: "rila-logo" },
    { id: 10, src: riseLogo, name: "rise-logo" },
    { id: 11, src: texttileEchangeLogo, name: "textile-exchange-logo" },
    { id: 12, src: wfsgiLogo, name: "wfsgi-logo" }
];

export default PartnershipImages;